(function (jedeye) {
    "use strict";
    jedeye(window.jQuery, window, document);

}(function ($, window, document) {
        "use strict";

        moment.locale($('html').attr('lang')); // Set momentJS locale

        $.fn.extend({
            animateCss: function (animationName) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                });
            },
            // Fit bootstrap modal to screen height when contents are too long
            fitModalToScreen: function () {
                if ($(window).width() < 992) return $(this);
                var height = $(window).height() - 255; //value corresponding to the modal heading + footer
                var targetFrame = $(this).find('.modal-frame').length > 0 ? '.modal-frame' : '.modal-body';
                $(targetFrame, this).css({"max-height": height, "overflow-y": "auto"});
                return $(this);
            }
        });

        // Global Utils
        window.JedeyeUtils = {
            scrollToElem: function ($elem, yoffset, duration) {
                yoffset = yoffset || 0;
                duration = duration || 500;
                $('html, body').animate({
                        scrollTop: $elem.offset().top + yoffset
                    }, {duration: duration}
                );
            },
            showBookingModal: function (elem) {
                var $baseEl = $(elem).closest('article');
                $('#bookingModal .booking-modal-icon').attr('src', $('.vehicle-pic', $baseEl).attr('src'));
                $('#bookingModal .m-subtitle').html($baseEl.data('group-model'));
            },
            triggerBookingFormSelection: function() {
                var $el = $('.booking-form:visible').find('[name="pickup_station"]'),
                    $form = $el.closest('form');

                window.JedeyeUtils.scrollToElem($form, -25, 1000);
                setTimeout(function() {
                    $el.select2('open');
                }, 1050);
            },
            manageExtrasHeadingVisibility: function() {
                if($('#bookingOptionalsList .extra-sb-item:visible').length > 0) {
                    $('#bookingOptionalsList thead').show();
                }else{
                    $('#bookingOptionalsList thead').hide();
                }
            }
        };

        var equalheight = function (container) {

            var currentTallest = 0,
                currentRowStart = 0,
                rowDivs = [],
                $el,
                topPosition = 0;

            $(container).each(function () {

                $el = $(this);
                $($el).height('auto');
                var topPostion = $el.position().top,
                    currentDiv = 0;

                if (currentRowStart != topPostion) {
                    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                        rowDivs[currentDiv].height(currentTallest);
                    }
                    rowDivs.length = 0; // empty the array
                    currentRowStart = topPostion;
                    currentTallest = $el.height();
                    rowDivs.push($el);
                } else {
                    rowDivs.push($el);
                    currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
                }
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
            });
        };

        $(window).on('ajaxUpdateComplete', function (event, context, data) {

            /**
             * Trigger custom alerts.
             */
            if (data.hasOwnProperty('alert')) {
                $(document).trigger("jedeye.showModalPopup", [data.alert.message, data.alert.title, data.alert.subtitle, data.alert.iconClass]);
            }

            // Manages modal triggering or dismissing from the server side responses
            if (data.hasOwnProperty('triggerModal')) {
                $(data.triggerModal).fitModalToScreen().modal('show');
            } else {
                if (data.hasOwnProperty('dismissModal')) {
                    $(data.dismissModal).modal('hide');
                }
            }
        });

        // Scrolls up on form validation error
        $('form[data-request],[data-request-form]').on('ajaxError', function (event, obj, context, status) {
            var $el = $(this).is('form') ? $(this) : $($(this).attr('data-request-form'));
            setTimeout(function () {
                var $errorElems = $el.find('.has-error:first');
                if ($errorElems.length > 0) {
                    $('html, body').animate({scrollTop: $errorElems.offset().top - 100}, 800);
                }
            }, 500);
        });

        // Enables form requests to be triggered by elements placed outside of it
        $('[data-request-target-elem]').on('click', function () {
            $($(this).data('request-target-elem')).submit();
        });


        $(document).router({
            // Homepage
            dom_home: function () {
                var refreshShowcaseProperties = function () {
                    if ($(window).width() < 2000) {
                        if ($(window).width() > 996) {
                            $('header.showcase').addClass('full-height');
                            $('header.showcase').height($(window).height());
                        } else {
                            $('header.showcase').height('auto');
                        }
                    } else {
                        $('header.showcase').removeClass('full-height');
                    }
                };

                $(window).on("resize", function () {
                    refreshShowcaseProperties();
                });

                refreshShowcaseProperties();

                if ($("#homeBannersSwiper .swiper-slide").length > 1) {
                    var homeSlideshowSwiper = new Swiper('#homeBannersSwiper', {
                        loop: true,
                        watchOverflow: true,
                        speed: 2000,
                        autoplay: 7000,
                        parallax: true,
                        effect: 'fade',
                        fade: {
                            crossFade: true
                        },
                        // Disable preloading of all images
                        preloadImages: false,
                        // Enable lazy loading
                        lazyLoading: true
                    });
                }
            },

            // Fleet pages
            dom_fleet: function () {
                $(function () {
                    // Multiple fleet swiper instances
                    $(".fleet-swiper").each(function (index, element) {
                        var $this = $(this);
                        var swiper = new Swiper(this, {
                            slidesPerView: 5,
                            spaceBetween: 0,
                            watchOverflow: true,
                            grabCursor: true,
                            breakpoints: {
                                1600: {
                                    slidesPerView: 4,
                                    spaceBetween: 0
                                },
                                1250: {
                                    slidesPerView: 3,
                                    spaceBetween: 0
                                },
                                996: {
                                    slidesPerView: 2,
                                    spaceBetween: 0
                                },
                                700: {
                                    slidesPerView: 1,
                                    spaceBetween: 0
                                }
                            },
                            nextButton: $this.parent().find(".swiper-button-next")[0],
                            prevButton: $this.parent().find(".swiper-button-prev")[0]
                        });
                    });

                    var adjustFleetSwiperSize = function () {
                        var $swiper = $('.fleet-swiper'),
                            maxHeight = 0;
                        $('article', $swiper).each(function () {
                            if ($(this).height() > maxHeight)
                                maxHeight = $(this).height();
                        });

                        $swiper.css({
                            'min-height': maxHeight + 130,
                        });
                    };

                    $(window).load(function () {
                        equalheight('.fleet-swiper figure');
                    });


                    $(window).resize(function () {
                        equalheight('.fleet-swiper figure');
                    });

                    setTimeout(adjustFleetSwiperSize, 200);
                });

            },

            dom_show_more_items: function ($targetEl) {

                if ($('.row.extras-container').length <= 2) {
                    $('.show-more-items-btn', $targetEl).parent().remove();
                } else {
                    $('.show-more-items-btn', $targetEl).on("click", function (e) {
                        e.preventDefault();
                        var $el = $(this),
                            $parent = $(this).parents('.extras-rows-container:first');
                        $parent.find('.row.hide').hide().removeClass('hide').slideDown(600, function () {
                            setTimeout(function () {
                                window.JedeyeUtils.scrollToElem($parent.find('.row:eq(3)'));
                            }, 100);
                        });
                        if ($parent.find('.row.hide').length == 0) {
                            $el.parent().hide();
                        }
                    }).removeClass('hide');
                }

            },

            dom_sticky_sidebar: function () {



                var sidebar = document.getElementById('sidebar');
                $(sidebar).stickySidebar({
                    topSpacing: -20,
                    bottomSpacing: 20,
                    containerSelector: '.main-content',
                    innerWrapperSelector: '.sidebar__inner',
                    minWidth: 992,
                    resizeSensor: true
                });
                sidebar.addEventListener('affix.static.stickySidebar', function () {
                    $(sidebar).removeClass('bs-affix-fix');
                });
                sidebar.addEventListener('affix.container-bottom.stickySidebar', function () {
                    $(sidebar).removeClass('bs-affix-fix');
                });
                sidebar.addEventListener('affix.unbottom.stickySidebar', function () {
                    $(sidebar).removeClass('bs-affix-fix');
                });
                sidebar.addEventListener('affix.top.stickySidebar', function () {
                    $(sidebar).addClass('bs-affix-fix');
                });
                sidebar.addEventListener('affix.bottom.stickySidebar', function () {
                    $(sidebar).addClass('bs-affix-fix');
                });
            },

            dom_booking_step_3: function () {

                $('.mobile-overlay').each(function () {
                    var $self = $(this);

                    $(document).on('scroll', function () {
                        if ($(document).scrollTop() >= $self.parent().position().top && $self.data('shown') != '1') {
                            $self.data('shown', '1');
                            setTimeout(function () {
                                $self.fadeOut(200);
                            }, 5000);
                        }
                    });

                    $self.on('mousedown', function () {
                        $self.fadeOut(200);
                    });
                });

                $(window).on('ajaxUpdateComplete', function(event, context, data, status, jqXHR) {
                    window.JedeyeUtils.manageExtrasHeadingVisibility();
                });

                window.JedeyeUtils.manageExtrasHeadingVisibility();
            },

            dom_booking_step_4: function () {
                $(function () {
                    var slideSpeed = 500;

                    $('.form-sub-container .show-btn').on("click", function (e) {
                        e.preventDefault();
                        var $el = $(this).closest('.form-sub-container');
                        $el.find('.section-body-container').slideDown(slideSpeed);
                        $el.removeClass('body-container-hidden');
                        $el.find('.section-enabled-flag').val('1');
                    });

                    $('.form-sub-container .hide-btn').on("click", function (e) {
                        e.preventDefault();
                        var $el = $(this).closest('.form-sub-container');
                        $el.find('.section-body-container').slideUp(slideSpeed);
                        $el.addClass('body-container-hidden');
                        $el.find('.section-enabled-flag').val('0');
                    });

                    $('#sameCustomerAsDriverNo').on("change", function () {
                        $('#customerMandatoryInfo').slideDown(slideSpeed);
                    });

                    $('#sameCustomerAsDriverYes').on("change", function () {
                        $('#customerMandatoryInfo').slideUp(slideSpeed);
                    });
                });

                $("#driver_birth_date").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": 18,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                $(".select-date-picker").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": 0,
                        "maxAge": 80,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                $(".select-date-picker-future").each(function () {
                    var defaultDate = $(this).data('default-date') || '';
                    if (defaultDate == '') {
                        defaultDate = false;
                    } else {
                        defaultDate = moment(defaultDate, 'YYYY-MM-DD');
                    }

                    $(this).selectDatePicker({
                        "minAge": -60,
                        "maxAge": 0,
                        "monthFormat": "short",
                        "defaultDate": defaultDate
                    });
                    $('select', this).each(function () {
                        $(this).wrap('<div class="col-xs-4"></div>');
                        $(this).select2({
                            // theme: "light",
                            minimumResultsForSearch: -1
                        });
                    });
                });

                window.JedeyeUtils.manageExtrasHeadingVisibility();

                // DatePickers
                // $(".date-picker").each(function () {
                //
                //     var $el = $(this);
                //
                //     // Date format sent to server
                //     var dateFormat = $(this).data('date-format') || "Y-m-d";
                //     // Date format presented to user
                //     var altFormat = $(this).data('alt-format') || "d/m/Y";
                //     // Date input mask presented to user
                //     var altMask = $(this).data('alt-mask') || "99/99/9999";
                //
                //     var yearSpan = 0,
                //         defaultYearSpan = 0;
                //     if ($(this).data('year-span') != null) {
                //         yearSpan = parseInt($(this).data('year-span'));
                //     }
                //     if ($(this).data('default-year-span') != null) {
                //         defaultYearSpan = parseInt($(this).data('default-year-span'));
                //     }
                //
                //     var minDate = $(this).hasClass('after-today') ? new Date(new Date().setFullYear(new Date().getFullYear() + yearSpan)) : null;
                //     var maxDate = $(this).hasClass('before-today') ? new Date(new Date().setFullYear(new Date().getFullYear() - yearSpan)) : null;
                //
                //     var defaultDate = defaultYearSpan > 0 ? new Date(new Date().setFullYear(new Date().getFullYear() + yearSpan)) : null;
                //     var locale = $('html').attr('lang');
                //
                //     var picker = $(this).flatpickr({
                //         dateFormat: dateFormat,
                //         altInputClass: "form-control",
                //         altInput: true,
                //         locale: locale,
                //         altFormat: altFormat,
                //         minDate: minDate,
                //         maxDate: maxDate,
                //         disableMobile: true,
                //         // allowInput: !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
                //         parseDate: function (dateStr) {
                //             var fmt = new DateFormatter();
                //             var date = fmt.parseDate(dateStr, altFormat);
                //             if (date == null)
                //                 return new Date();
                //
                //             return date;
                //         },
                //     });
                //
                //     if (yearSpan > 0) {
                //         if (minDate != null) {
                //             picker.jumpToDate(minDate);
                //         } else if (maxDate != null) {
                //             picker.jumpToDate(maxDate);
                //         }
                //     }
                //
                //     if (defaultDate != null) {
                //         picker.jumpToDate(defaultDate);
                //     }
                //
                //     // Date mask
                //     // $(this).parent().find('.flatpickr-input').each(function () {
                //     //     if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                //     //         $(this).mask(altMask);
                //     //     }
                //     //     $(this).on('change', function () {
                //     //         $el.val($(this).val());
                //     //     });
                //     // });
                // });
            },

            dom_booking_step_5: function () {
                $(function () {
                    $('.round-radio-block').on("click", function () {
                        $(this).parents('.section-body-container:first').find('.round-radio-block').removeClass('active');
                        $(this).find('input[type=radio]').prop("checked", true);
                        $(this).addClass('active');
                    });
                });

                window.JedeyeUtils.manageExtrasHeadingVisibility();
            },

            dom_booking: function () {
                // Booking summary top bar
                $(window).scroll(function () {
                    // var $elem = $('.booking-bar').eq(0);
                    // if ($(window).scrollTop() > $elem.offset().top) {
                    //     $('.booking-summary-bar').removeClass('animate-out').addClass('animate-in');
                    // } else {
                    //     $('.booking-summary-bar.animate-in').removeClass('animate-in').addClass('animate-out');
                    // }


                    var $elem2 = $('.header-attachment').eq(0);
                    if ($(window).scrollTop() > ($elem2.offset().top + $elem2.outerHeight())) {
                        $('.header-attachment-placeholder').css('height', $('.header-attachment-sub').outerHeight());
                        $('.header-attachment-sub').addClass('fixed');
                    } else {
                        $('.header-attachment-placeholder').css('height', 0);
                        $('.header-attachment-sub').removeClass('fixed');
                    }
                });
            },

            dom_insurances_table: function () {
                $('#insurancePackages tfoot td').not('.active,.bg-secondary').hover(function () {
                    var index = $(this).index() - 1;
                    $('#insurancePackages tbody tr').each(function () {
                        $('td', $(this)).eq(index).addClass('hover');
                    });

                }, function () {
                    var index = $(this).index() - 1;
                    $('#insurancePackages tbody tr').each(function () {
                        $('td', $(this)).eq(index).removeClass('hover');
                    });
                });
            },

            dom_stations_maps: function () {

                var nl2br = function (str, is_xhtml) {
                    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
                };

                $(function () {

                    var reloadMapProperties = function (mapInstance, stationElem) {
                        mapInstance.removeMarkers();
                        mapInstance.addMarker({
                            lat: parseFloat(stationElem.data('lat')),
                            lng: parseFloat(stationElem.data('lng')),
                            title: stationElem.data('title'),
                        });
                        mapInstance.setCenter(stationElem.data('lat'), stationElem.data('lng'));
                        mapInstance.refresh();
                    };

                    $('.station-info').each(function () {
                        var $stationPopup = $(this),
                            $stationElem = $('.station-info-data', $stationPopup),
                            defaultIcon = $('.pre-icon', $stationPopup).data('default-img');

                        if ($stationElem.length > 0) {

                            $('.contact-us-btn', $stationElem).on('click', function () {
                                if ($(this).data('target-url')) {
                                    window.location = $(this).data('target-url');
                                } else {
                                    $('html, body').animate({scrollTop: $('form:first').length > 0 ? $('form:first').parent().offset().top - 100 : 0}, 800, function () {
                                        $('form:first input:first').trigger('focus');
                                    });
                                }
                            });

                            $('.stations-list .btn-trigger').off("click").on("click", function () {
                                // Load data
                                var $dataEl = $(this).closest('li'),
                                    data = $dataEl.data('info'),
                                    name = $dataEl.data('name'),
                                    group = $dataEl.data('group');

                                $('.st-title', $stationElem).html(name).parent().attr('style', !name ? 'display: none' : '');
                                $('.st-group', $stationElem).html(group).parent().attr('style', !group ? 'display: none' : '');
                                $('.st-address', $stationElem).html(nl2br(data.address)).parent().attr('style', !data.address ? 'display: none' : '');
                                $('.st-observations', $stationElem).html(nl2br(data.observations)).parent().attr('style', !data.observations ? 'display: none' : '');
                                $('.st-phone-1', $stationElem).html(data.phone).parent().attr('style', !data.phone ? 'display: none' : '');
                                $('.st-email', $stationElem).html(data.email).parent().attr('style', !data.email ? 'display: none' : '');
                                $('.st-schedule-open', $stationElem).html(nl2br(data.schedule)).parent().attr('style', !data.schedule ? 'display: none' : '');

                                if ($dataEl.data('lat') != '' && $dataEl.data('lng') != '') {
                                    $stationElem.data('lat', $dataEl.data('lat'));
                                    $stationElem.data('lng', $dataEl.data('lng'));
                                } else {
                                    $stationElem.data('lat', 0);
                                    $stationElem.data('lng', 0);
                                }

                                $stationElem.data('title', name);

                                $stationPopup.removeClass('animate-in animate-out').addClass('animate-in').show();

                                var minSize = $('.top-side > div:eq(1)', $stationPopup).outerHeight();
                                if (minSize < 298) {
                                    minSize = 298;
                                }
                                setTimeout(function () {
                                    $('.top-side > div:eq(0)', $stationPopup).css('height', minSize + 'px');
                                }, 100);

                                // Update .station-info-data from server and then reload map properties
                                reloadMapProperties(map, $stationElem);
                                if ($stationPopup.data('loaded') != true) {
                                    setTimeout(function () {
                                        reloadMapProperties(map, $stationElem);
                                        reloadMapProperties(map, $stationElem);
                                        $stationPopup.data('loaded', true);
                                    }, 150);
                                }
                            });

                            var map = new GMaps({
                                div: '.map',
                                lat: 41.01369,
                                lng: -8.4093757,
                                enableNewStyle: true,
                                fullscreenControl: false,
                                zoom: 12
                            });

                            $(this).on('click', '.close-icon', function () {
                                $stationPopup.removeClass('animate-in animate-out').addClass('animate-out');
                                setTimeout(function () {
                                    $stationPopup.hide();
                                }, 1000);
                            });
                        }
                    });
                });
            },

            dom_popovers: function () {

                $(function () {
                    $('[data-toggle="popover"]:not([data-event-attached])').each(function () {
                        var $el = $(this);
                        $el.popover({
                            placement: $el.data('placement'),
                            viewport: $el.data('viewport')
                        });
                        $(this).attr('data-event-attached', '');
                    });

                });
            },

            scroll_stripe: function () {
                $.scrolline({
                    frontColor: '#62A60A',
                    backColor: 'transparent'
                });
            },

            custom_select: function () {
                $(".custom-select").each(function () {
                    var $el = $(this);
                    $el.select2({
                        minimumResultsForSearch: $el.hasClass('searchable') ? 0 : -1,
                        placeholder: $el.data('placeholder') !== undefined ? $el.data('placeholder') : false,
                        templateSelection: function (item) {
                            if ($el.data('svg-icon')) {
                                return $(
                                    '<span><svg class="icon"><use xlink:href="' + svgDefs + '#icon-' + $el.data('svg-icon') + '"></use></svg>' + item.text + '</span>'
                                );
                            }
                            return item.text;
                        }
                    });
                });
            },

            // Shared code
            common: function () {
                function showModalPopup(message, title, subtitle, iconClass) {
                    title = title || '';
                    subtitle = subtitle || '';
                    message = message || '';
                    iconClass = iconClass || '';
                    var $modal = $('#appModal:first');
                    $('.m-title', $modal).html(title);
                    $('.m-subtitle', $modal).html(subtitle);
                    $('.m-message', $modal).html(message);
                    $('#appModalIcon', $modal).removeClass().addClass('icon').addClass(iconClass);
                    $modal.modal('show');
                }

                $(document).on('jedeye.showModalPopup', function (event, message, title, subtitle, iconClass) {
                    showModalPopup(message, title, subtitle, iconClass);
                });

                // code put inside the common property will be executed on all page loads
                function centerModal() {
                    $(this).css('display', 'block');
                    var $dialog = $(this).find(".modal-dialog"),
                        offset = ($(window).height() - $dialog.height()) / 2,
                        bottomMargin = parseInt($dialog.css('marginBottom'), 10);

                    // Make sure you don't hide the top part of the modal w/ a negative margin if it's longer than the screen height, and keep the margin equal to the bottom margin of the modal
                    if (offset < bottomMargin) offset = bottomMargin;
                    $dialog.css("margin-top", offset);
                }

                $(document).on('show.bs.modal', '.modal', centerModal);
                $(window).on("resize", function () {
                    $('.modal:visible').each(centerModal);
                });

                $(function () {
                    $(".custom-select").each(function () {
                        var $el = $(this);
                        $el.select2({
                            minimumResultsForSearch: $el.hasClass('searchable') ? 0 : -1,
                            placeholder: $el.data('placeholder') !== undefined ? $el.data('placeholder') : false,
                            templateSelection: function (item) {
                                if ($el.data('svg-icon')) {
                                    return $(
                                        '<span><svg class="icon"><use xlink:href="' + svgDefs + '#icon-' + $el.data('svg-icon') + '"></use></svg>' + item.text + '</span>'
                                    );
                                }
                                return item.text;
                            }
                        });
                    });

                    $('.mobile-main-menu').sliiide({
                        toggle: "#mobileMenuToggle", // the selector for the menu toggle, whatever clickable element you want to activate or deactivate the menu. A click listener will be added to this element.
                        exit_selector: ".mobile-main-menu .close", // the selector for an exit button in the div if needed, when the exit element is clicked the menu will deactivate, suitable for an exit element inside the nav menu or the side bar
                        animation_duration: "0.5s", //how long it takes to slide the menu
                        place: "left", //where is the menu sliding from, possible options are (left | right | top | bottom)
                        animation_curve: "cubic-bezier(0.54, 0.01, 0.57, 1.03)", //animation curve for the sliding animation
                        body_slide: true, //set it to true if you want to use the effect where the entire page slides and not just the div
                        no_scroll: true, //set to true if you want the scrolling disabled while the menu is active,
                        onAnimationStart: function (obj, type) {
                            if (type == 'open') {
                                $("#mobileMenuToggle").animate({
                                    opacity: 0
                                }, 50);
                                $(".mobile-main-menu .close").animate({
                                    opacity: 1
                                }, 200);
                            } else {
                                $("#mobileMenuToggle").animate({
                                    opacity: 1
                                }, 200);
                                $(".mobile-main-menu .close").animate({
                                    opacity: 0
                                }, 200);
                            }
                        }

                    });

                    $('[data-toggle="tooltip"]').tooltip();

                    // Scroll to Top Arrow
                    $(window).scroll(function () {
                        if ($(this).scrollTop() > 500) {
                            if ($('#scrollToTop').data('hidden') != '0') {
                                $('#scrollToTop:hidden').data('hidden', '0').stop(true, true).fadeIn();
                            }
                        } else {
                            if ($('#scrollToTop').data('hidden') == 0) {
                                $('#scrollToTop').data('hidden', '1').stop(true, true).fadeOut();
                            }
                        }
                    });

                    //Click event to scroll to top
                    $('#scrollToTop').click(function () {
                        $(this).data('hidden', '1').stop(true, true).fadeOut();
                        $('html, body').animate({scrollTop: 0}, 800);
                        return false;
                    });
                });

                // Loading Indicator
                +function ($) {
                    delete $.oc.stripeLoadIndicator;

                    $(document)
                        .off('ajaxPromise', '[data-stripe-load-indicator]');

                    $.oc.stripeLoadIndicator = null;

                    var StripeLoadIndicator = function () {
                        $('.stripe-loading-indicator').remove(); // Remove original stripLoadIndicator
                    };

                    StripeLoadIndicator.prototype.show = function () {
                        $('.spinner-overlay').show();
                        $(document.body).addClass('loading');
                    };

                    StripeLoadIndicator.prototype.hide = function (force) {
                        $('.spinner-overlay').hide();
                        $(document.body).removeClass('loading');
                    };

                    $(document).ready(function () {
                        $.oc.stripeLoadIndicator = new StripeLoadIndicator();
                    });

                    // STRIPE LOAD INDICATOR DATA-API
                    // ==============

                    $(document)
                        .on('ajaxPromise', '[data-stripe-load-indicator]', function (event) {
                            // Prevent this event from bubbling up to a non-related data-request
                            // element, for example a <form> tag wrapping a <button> tag
                            event.stopPropagation()

                            $.oc.stripeLoadIndicator.show()

                            // This code will cover instances where the element has been removed
                            // from the DOM, making the resolution event below an orphan.
                            var $el = $(this)
                            $(window).one('ajaxUpdateComplete', function () {
                                if ($el.closest('html').length === 0)
                                    $.oc.stripeLoadIndicator.hide()
                            })
                        }).on('ajaxFail ajaxDone', '[data-stripe-load-indicator]', function (event) {
                        event.stopPropagation()
                        $.oc.stripeLoadIndicator.hide()
                    })

                }(window.jQuery);
            }
        }, true);
    }
));
